import { ReactNode, createContext, useContext } from "react";
import { WaiverFormItem } from "../waiverApi";
import useWaiverSubmit, { WaiverSubmitState } from "./useWaiverSubmit";

export const WaiverSubmitContext = createContext<WaiverSubmitState>(
  {} as WaiverSubmitState
);

export default function WaiverSubmitProvider({
  children,
  previewItem,
}: {
  children: ReactNode;
  id?: any;
  previewItem?: WaiverFormItem;
}) {
  const value = useWaiverSubmit({ previewItem });
  return (
    <WaiverSubmitContext.Provider value={value}>
      {children}
    </WaiverSubmitContext.Provider>
  );
}

export const useWaiverSubmitState = () => {
  const ctx = useContext(WaiverSubmitContext);

  if (!ctx) {
    throw new Error("You need wrap your app with WaiverSubmitProvider");
  }

  return ctx;
};
